




























































































































































































































































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Container} from "typescript-ioc";
import Paging from 'biz-ts/src/api/Paging';
import ProductMac from "@/model/ProductMac";
import PaginationTable from "@/component/Table/pagination-table.vue";
import ProductMacApi, {PmacPqForm, PmacRegisterForm, TestResult} from "@/module/device/ProductMacApi";
import productModule from "@/store/module/ProductModule";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CreateDialog from "@/component/Crud/create-dialog.vue";
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import ConfirmDialog from "@/component/Dialog/confirm-dialog.vue";
import WarnDialog from "@/component/Dialog/warn-dialog.vue";
import {PmacImportForm} from "@/form/ProductForm";
import MacUtil from 'tools-ts/src/util/MacUtil';
import {BatchResult} from "biz-ts/src/api/BatchActionReturn";
import {MessageType} from "element-ui/types/message";
import _ from 'lodash';
import {handleBatchReturn} from "@/util/HandleBatchReturn";
import SingleDayColumn from "@/component/Table/single-day-column.vue";
import Device from "@/model/Device";
import ProductMacTestReport from "@/view/device-manage/product/mac-test-report.vue";
import IdColumn from "@/component/Table/id-column.vue";
import {handleClipboard} from "@/util/clipboard";

@Component({
  components: {
    IdColumn,
    RefreshButton,
    PaginationTable,
    CreateDialog,
    DeleteDialog,
    ConfirmDialog,
    WarnDialog,
    SingleDayColumn,
    ProductMacTestReport,
  },
})
export default class ProductMacView extends Vue {

  private pmacApi = Container.get(ProductMacApi)

  @Ref()
  private ptable!: PaginationTable

  private get product() {
    return productModule.active
  }

  private active = new ProductMac()

  private paging = new Paging<ProductMac>()
  private pqForm = new PmacPqForm(this.product.id)

  private TestResult = TestResult

  async refresh() {
    await this.ptable?.refresh()
  }

  private async search(reset = false) {
    if (reset)
      this.pqForm.currentPage = 1
    this.refresh()
  }

  private async getPaging() {
    return this.pmacApi.paging(this.pqForm)
  }

  @Ref()
  private registerDialog!: CreateDialog

  private registerForm = new PmacRegisterForm(this.product.id)

  private async beforeOpenCreateForm() {
    this.registerForm.init(this.product.id)
  }

  private async reigster() {
    await this.pmacApi.register(this.registerForm)
  }

  @Ref()
  private importDialog!: CreateDialog

  private importForm = new PmacImportForm(this.product.id)

  private importMacs = ""

  private async initImportForm() {
    this.importMacs = ""
  }

  private async doImport() {
    const macs = this.importMacs.split(/\r?\n/)
    this.importForm.macs = _.filter(macs, mac => {
      return !_.isEmpty(mac)
    })
    const rt = await this.pmacApi.import(this.importForm)
    const errsMap = rt.validErrorsMap
    const result = rt.result

    let title = ''
    let type: MessageType = 'error'
    switch (result) {
      case BatchResult.NO_DATA:
        title = "无数据导入"
        type = "warning"
        break
      case BatchResult.SUCCESS:
        title = "导入成功"
        type = "success"
        break
      case BatchResult.FAIL:
        title = "导入失败"
        type = "error"
        break
      case BatchResult.PARTIAL_FAIL:
        title = "导入部分失败"
        type = 'warning'
        break
    }

    handleBatchReturn({
      errsMap: errsMap,
      successData: rt.successData,
      title: title,
      type: type,
    })
  }

  @Ref()
  private deleteDialog!: DeleteDialog

  private async deleteProductMac() {
    await this.pmacApi.delete(this.active.id)
  }

  private randomMac() {
    this.registerForm.mac = MacUtil.random()
  }

  @Ref()
  private batchDeleteDialog!: DeleteDialog

  private showAllDeleted = false

  private get selection() {
    // @ts-ignore
    return this.ptable?.table?.selection
  }

  private get deletableSelection() {
    return this.selection?.filter((it: ProductMac) => {
      return it.deletable
    })
  }

  private get undeletableSelection() {
    return this.selection?.filter((it: ProductMac) => {
      return !it.deletable
    })
  }

  private handleBatchDeleteBtnClick() {
    if (_.isEmpty(this.selection)) {
      this.$message.warning('请选择至少一个 Mac')
      return
    }
    this.showAllDeleted = true
    this.batchDeleteDialog.open()
  }

  private async batchDelete() {
    const rt = await this.pmacApi.batchDelete(
        this.selection.map((it: Device) => {
          return it.id
        })
    )

    let title = ''
    let type: MessageType = 'error'
    switch (rt.result) {
      case BatchResult.NO_DATA:
        title = "无数据删除"
        type = "warning"
        break
      case BatchResult.SUCCESS:
        title = "批量删除成功"
        type = "success"
        break
    }

    handleBatchReturn({
      successData: rt.successData,
      title: title,
      type: type,
    })
  }

  @Ref()
  private testReport!: ProductMacTestReport

  private onMacChange() {
    const mac = this.registerForm.mac
        .split('-')
        .join('')
        .toLowerCase()
    this.registerForm.mac = mac
  }

  private lastTestResultTagcfg(lastTestResult: boolean | undefined) {
    const cfg = {
      type: 'warning',
      text: '未测试'
    }
    switch (lastTestResult) {
      case true:
        cfg.type = 'success'
        cfg.text = '成功'
        break;
      case false:
        cfg.type = 'danger'
        cfg.text = '失败'
        break;
    }
    return cfg
  }

  private copy = handleClipboard
}
